<template>
  <header-admin :active-section="activeSection" />
  <div class="overflow-auto d-flex justify-content-between">
    <button
      to="/admin/centers"
      class="btn btn-grey mt-4 mb-2 mx-3 align-self-start"
      @click="backToAllCenters"
    >
      <i class="far fa-arrow-left" />
      <span>{{ trans("region.backToAllCenters") }}</span>
    </button>

    <div class="mt-4 mb-2 mx-3">
      <!--      <h3 class="centerName">
        {{ selectedCenterName }}
      </h3>-->
    </div>
  </div>
  <center-header
    :selected-menu-item="selectedMenuItem"
    :center-not-active="centerNotActive"
    :disable-groups-menu="newCenter"
  />
</template>
<script>
import CenterHeader from "../../Center/CenterHeader.vue";
import HeaderAdmin from "../Header.vue";

export default {
  components: { HeaderAdmin, CenterHeader },
  props: [
    "selectedMenuItem",
    "selectedCenterName",
    "activeSection",
    "centerNotActive",
    "newCenter",
  ],
  methods: {
    backToAllCenters() {
      this.$router.push("/admin/centers");
    },
  },
};
</script>
